module.exports = __webpack_public_path__ + "img/mpeg.ce1474bd.svg";